import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Advertiser } from '_models/affiliate-network-advertisers-data';

@Component({
  selector: 'app-edit-advertiser-modal',
  templateUrl: './edit-advertiser-modal.component.html',
  styleUrls: ['./edit-advertiser-modal.component.css']
})
export class EditAdvertiserModalComponent implements OnInit {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Input() public advertiser: Advertiser;

  constructor( public activeModal: NgbActiveModal) { }

  ngOnInit() {
    console.log('before update=');
    console.log(this.advertiser);
  }

  updateAdvertiser() {
    this.passEntry.emit(this.advertiser);
    this.advertiser = null;
    this.activeModal.close();
  }

}
